export default "__VITE_ASSET__D3lK9REl__"